import api from "@core/plugins/api";
import { API_NAMESPACE_CANDIDATE } from "@core/constants/api.constants";

/**
 * Get FeatureToggles API Rest Endpoint
 *
 * @param {"ex" | "et"} [namespace="ex"] - "ex"
 * @returns
 */
const featureTogglesGetPrivateURL = (namespace = API_NAMESPACE_CANDIDATE) => `/${namespace}/feature-toggles`;
const featureTogglesGetURL = `/feature-toggles`;

export class FeatureTogglesService {
  /**
   * Get private feature toggles from API
   *
   * @param {"ex" | "et"} [namespace="ex"] - "ex"
   * @returns
   */
  static async getPrivate(namespace = API_NAMESPACE_CANDIDATE) {
    try {
      const { data } = await api.private.get(featureTogglesGetPrivateURL(namespace));
      return data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get public feature toggles from API
   *
   * @returns
   */
  static async getPublic() {
    try {
      const { data } = await api.private.get(featureTogglesGetURL);
      return data;
    } catch (error) {
      throw error;
    }
  }
}
